import { ComponentProps } from 'react'

import cn from '@/utilities/cn'

export default function Skeleton({ className, ...rest }: ComponentProps<'div'>) {
  return <div className={cn('animate-pulse rounded-md bg-zinc-100', className)} {...rest} />
}
